//Basic Popover
export const BASIC_POPOVER_DATA = [
  {
    text: "Use the",
    code: " data-bs-toggle='popover'",
  },
  {
    text: "through popover above buttons.",
  },
];

export const BASIC_POPOVER_LIST = [
  {
    id: 2,
    placement: "bottom",
    Popoverheader: "Hover Popover",
    Popoverbody: "Several utility instruction sets have been featured in the Bootstrap 4 to promote very easy learning for beginners in the business of web building.",
    btnColor: "secondary",
    btntext: "Hover tooltip",
    trigger:"hover",
  },
  {
    id: 3,
    Popoverheader: "Dismissible popover",
    Popoverbody: "You are able to even develop and suggest improvements to the Bootstrap 4 before its final version is delivered.",
    btnColor: "success",
    btntext: "Dismissible popover",
    trigger:"click",
  },
];

//Popover Direction
export const DIRECTION_DATA = [
  {
    text: "Use the",
    code: " data-bs-toggle='popover'",
  },
  {
    text: "through popover directions above buttons. ",
  },
];

export const DIRECTION_LIST = [
  {
    id: 5,
    placement: "right",
    Popoverheader: "Popover On Right",
    Popoverbody: "Popovers are opt-in for effectiveness causes, in this way you have to initialize them yourself.",
    btnColor: "primary",
    btntext: "Popover on right",
  },
  {
    id: 6,
    placement: "bottom",
    Popoverheader: "Popover On Bottom",
    Popoverbody: "Identify container:to evade rendering problems in more complex components (like Bootstrap input groups, button groups, etc).",
    btnColor: "info",
    btntext: "Popover on bottom",
  },
  {
    id: 7,
    placement: "left",
    Popoverheader: "Popover On Left",
    Popoverbody: "Popovers are opt-in for effectiveness causes, in this way you have to initialize them yourself.",
    btnColor: "dark",
    btntext: "Popover on left",
  },
];

//Popover Offset
export const OFFSET_DATA = [
  {
    text: "Use the",
    code: ' data-bs-offset="*,*"',
  },
  {
    text: " through popover offset above buttons. ",
  },
];

export const OFFSET_LIST = [
  {
    id: 9,
    placement: "left-end",
    Popoverheader: "Popover On Left",
    Popoverbody: "Popovers are opt-in for effectiveness causes, in this way you have to initialize them yourself.",
    btnColor: "primary",
    btntext: "Popover offset -50",
  },
];
